// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__Ci5Cs","skeleton-animation":"styles_skeleton-animation__K6NzG"};